<template>
  <div v-if="visibleSearches.length">
    <div class="flex items-center justify-between">
      <h3 class="text-text-neutral-primary text-base font-medium">
        {{ t('recentSearches.title') }}
      </h3>
      <button
        class="text-text-positive-primary text-sm font-medium"
        @click="handleClear"
      >
        {{ t('recentSearches.clear') }}
      </button>
    </div>
    <div
      class="-mx-4 mt-3 flex gap-2 overflow-x-auto px-4"
      style="scrollbar-width: none"
    >
      <RecentSearchCard
        v-for="(search, index) in visibleSearches"
        :key="search.timestamp"
        :search="search"
        :index="index"
        @onClick="handleCardClick(search, index)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';

  import type { RecentSearch } from '@/entities/recent-searches';

  import { analyticsEventsLib, type MainPageVariant } from '@/shared/lib';

  import { useRecentSearchesList } from '../model/use-recent-searches-list';
  import RecentSearchCard from './RecentSearchCard.vue';

  const { t } = useI18n();

  const props = defineProps<{
    variant?: MainPageVariant;
  }>();

  const emit = defineEmits<{
    onSearchClick: [search: RecentSearch, index: number];
  }>();

  const { visibleSearches, clearAll } = useRecentSearchesList();

  const handleCardClick = (search: RecentSearch, index: number) => {
    analyticsEventsLib.lastSearchesClick(index + 1, props.variant);
    emit('onSearchClick', search, index);
  };

  const handleClear = () => {
    clearAll();
  };

  onMounted(() => {
    if (visibleSearches.value.length) {
      analyticsEventsLib.lastSearchesShow(props.variant);
    }
  });
</script>
